import _typeof from "@babel/runtime/helpers/typeof";
export var FunctionTypes;
(function (FunctionTypes) {
  FunctionTypes["ARTIST"] = "artist";
  FunctionTypes["ADAPTER"] = "adapter";
  FunctionTypes["AUTHOR"] = "author";
  FunctionTypes["EDITOR"] = "editor";
  FunctionTypes["COMPILER"] = "compiler";
  FunctionTypes["CREATOR"] = "creator";
  FunctionTypes["DIRECTOR"] = "director";
  FunctionTypes["INTERVIEWER"] = "interviewer";
  FunctionTypes["INTERVIEWEE"] = "interviewee";
  FunctionTypes["PERFORMER"] = "performer";
  FunctionTypes["PRODUCER"] = "producer";
  FunctionTypes["REVIEWER"] = "reviewer";
  FunctionTypes["REVIEWED"] = "reviewed";
  FunctionTypes["SCREENWRITER"] = "screenwriter";
  FunctionTypes["TRANSLATOR"] = "translator";
  FunctionTypes["WRITER"] = "writer";
  FunctionTypes["SECTION_AUTHOR"] = "section_author";
  FunctionTypes["SECTION_EDITOR"] = "section_editor";
  FunctionTypes["SECTION_COMPILER"] = "section_compiler";
  FunctionTypes["SECTION_TRANSLATOR"] = "section_translator";
  FunctionTypes["SINGER"] = "singer";
  FunctionTypes["CONDUCTOR"] = "conductor";
  FunctionTypes["ORCHESTRATOR"] = "orchestrator";
  FunctionTypes["EMAIL_TO"] = "to";
  FunctionTypes["EMAIL_FROM"] = "from";
  FunctionTypes["CHOREOGRAPHER"] = "choreographer";
  FunctionTypes["NARRATOR"] = "narrator";
})(FunctionTypes || (FunctionTypes = {}));
var getDefaultOptionValue = function getDefaultOptionValue(options) {
  return _typeof(options[0]) === 'object' ? options[0].value : options[0];
};
export function getDefaultContributorState(functionOptions) {
  return {
    "function": getDefaultOptionValue(functionOptions),
    firstName: '',
    middleName: '',
    lastName: '',
    data: {
      suffix: ''
    }
  };
}